// City autocomplete using Mapbox Forward Geocoding (places type only).
// Returns: { city, state, country, lat, lng, display }.
import { MAPBOX_TOKEN } from "@/lib/mapbox";

const GEO_BASE = "https://api.mapbox.com/geocoding/v5/mapbox.places";

export async function searchCities(query, { limit = 6, signal } = {}) {
  const q = (query || "").trim();
  if (q.length < 2 || !MAPBOX_TOKEN) return [];
  const url =
    `${GEO_BASE}/${encodeURIComponent(q)}.json?` +
    `access_token=${MAPBOX_TOKEN}&autocomplete=true&language=en&limit=${limit}&types=place,locality,district`;
  try {
    const r = await fetch(url, { signal });
    if (!r.ok) return [];
    const d = await r.json();
    return (d.features || []).map((f) => {
      const ctx = f.context || [];
      const find = (k) => ctx.find((c) => c.id?.startsWith(k))?.text || null;
      return {
        city: f.text,
        state: find("region") || null,
        country: find("country") || null,
        lat: f.center?.[1] ?? null,
        lng: f.center?.[0] ?? null,
        display: f.place_name,
      };
    });
  } catch {
    return [];
  }
}
